import { createAction } from '@reduxjs/toolkit';
import { AppNotificationInterface } from '../../models/AppNotification';

export enum ActionType {
  PUSH = 'notifications/push',
  SHIFT = 'notifications/shift',
  REMOVE = 'notifications/remove',
  REMOVE_LIST = 'notifications/remove-list',
  RESET = 'notifications/reset',
}

const actions = {
  push: createAction<AppNotificationInterface>(ActionType.PUSH),
  shift: createAction<void>(ActionType.SHIFT),
  remove: createAction<AppNotificationInterface>(ActionType.REMOVE),
  removeList: createAction<AppNotificationInterface[]>(ActionType.REMOVE_LIST),
  reset: createAction<void>(ActionType.RESET),
};

export default actions;
